

export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_START = 'AUTH_START';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';

export const FETCH_SERVICE_ORDER_DETAIL = "FETCH_SERVICE_ORDER_DETAIL"
export const RECEIVE_SERVICE_ORDER_DETAIL = "RECEIVE_SERVICE_ORDER_DETAIL"
export const FETCH_SERVICE_ORDER_PROCESS_DETAIL = "FETCH_SERVICE_ORDER_PROCESS_DETAIL"
export const RECEIVE_SERVICE_ORDER_PROCESS_DETAIL = "RECEIVE_SERVICE_ORDER_PROCESS_DETAIL"
export const FETCH_SERVICE_ORDER_SERVICE_DETAIL = "FETCH_SERVICE_ORDER_SERVICE_DETAIL"
export const RECEIVE_SERVICE_ORDER_SERVICE_DETAIL = "RECEIVE_SERVICE_ORDER_SERVICE_DETAIL"
export const FETCH_TIRE_BRANDS = "FETCH_TIRE_BRANDS"
export const RECEIVE_TIRE_BRANDS = "RECEIVE_TIRE_BRANDS"
export const NEW_TIRE_BRAND = 'NEW_TIRE_BRAND'
export const NEW_TIRE_BRAND_SUCCESS = 'NEW_TIRE_BRAND_SUCCESS'
export const FETCH_TIRE_MODELS = 'FETCH_TIRE_MODELS'
export const NEW_TIRE_MODEL = 'NEW_TIRE_MODEL'
export const NEW_TIRE_MODEL_SUCCESS = 'NEW_TIRE_MODEL_SUCCESS'
export const RECEIVE_TIRE_MODELS = 'RECEIVE_TIRE_MODELS'
export const FETCH_TIRE_SIZES = 'FETCH_TIRE_SIZES'
export const NEW_TIRE_SIZE = 'NEW_TIRE_SIZE'
export const NEW_TIRE_SIZE_SUCCESS = 'NEW_TIRE_SIZE_SUCCESS'
export const NEW_BANDA = 'NEW_BANDA'
export const NEW_BANDA_SUCCESS = 'NEW_BANDA_SUCCESS'
export const RECEIVE_TIRE_SIZES = 'RECEIVE_TIRE_SIZES'
export const FETCH_RASPA_RECIPES = 'FETCH_RASPA_RECIPES'
export const NEW_RASPA_RECIPE = 'NEW_RASPA_RECIPE'
export const NEW_RASPA_RECIPE_SUCCESS = 'NEW_RASPA_RECIPE_SUCCESS'
export const RECEIVE_RASPA_RECIPES = 'RECEIVE_RASPA_RECIPES'
export const FETCH_RASPA_CYCLES = 'FETCH_RASPA_CYCLES'
export const NEW_RASPA_CYCLE = 'NEW_RASPA_CYCLE'
export const NEW_RASPA_CYCLE_SUCCESS = 'NEW_RASPA_CYCLE_SUCCESS'
export const RECEIVE_RASPA_CYCLES = 'RECEIVE_RASPA_CYCLES'
export const RECEIVE_PRODUCTION_STATISTICS_BY_STATION = 'RECEIVE_PRODUCTION_STATISTICS_BY_STATION';
export const FETCH_PRODUCTION_STATISTICS_BY_STATION = 'FETCH_PRODUCTION_STATISTICS_BY_STATION';
export const FETCH_SERVICE_ORDER_PRODUCTION_STATISTICS = 'FETCH_SERVICE_ORDER_PRODUCTION_STATISTICS';
export const RECEIVE_SERVICE_ORDER_PRODUCTION_STATISTICS = 'RECEIVE_SERVICE_ORDER_PRODUCTION_STATISTICS'
export const GET_GLOBAL_FILTERS = 'GET_GLOBAL_FILTERS';
export const CHANGE_FILTER = 'CHANGE_FILTER';
export const FETCH_RASPA_CYCLE_HOUR_USAGE_STATISTICS = 'FETCH_RASPA_CYCLE_HOUR_USAGE_STATISTICS';
export const RECEIVE_RASPA_CYCLE_HOUR_USAGE_STATISTICS =  'RECEIVE_RASPA_CYCLE_HOUR_USAGE_STATISTICS';
export const FETCH_RASPA_RECIPE_USAGE_STATISTICS = 'FETCH_RASPA_RECIPE_USAGE_STATISTICS';
export const RECEIVE_RASPA_RECIPE_USAGE_STATISTICS = 'RECEIVE_RASPA_RECIPE_USAGE_STATISTICS';
export const FETCH_RASPAS = 'FETCH_RASPAS';
export const RECEIVE_RASPAS = 'RECEIVE_RASPAS';

export const FETCH_RASPA_ALARMS = 'FETCH_RASPA_ALARMS'
export const NEW_RASPA_ALARM = 'NEW_RASPA_ALARM'
export const NEW_RASPA_ALARM_SUCCESS = 'NEW_RASPA_ALARM_SUCCESS'
export const RECEIVE_RASPA_ALARMS = 'RECEIVE_RASPA_ALARMS'
export const FETCH_RASPA_ALARM_USAGE_STATISTICS = 'FETCH_RASPA_ALARM_USAGE_STATISTICS';
export const RECEIVE_RASPA_ALARM_USAGE_STATISTICS = 'RECEIVE_RASPA_ALARM_USAGE_STATISTICS';
export const FETCH_SERVICE_ORDER_TIRE_STATISTICS = 'FETCH_SERVICE_ORDER_TIRE_STATISTICS';
export const RECEIVE_SERVICE_ORDER_TIRE_STATISTICS = 'RECEIVE_SERVICE_ORDER_TIRE_STATISTICS';
export const FETCH_SERVICE_ORDER_TIRE_MODEL_STATISTICS = 'FETCH_SERVICE_ORDER_TIRE_MODEL_STATISTICS';
export const RECEIVE_SERVICE_ORDER_TIRE_MODEL_STATISTICS = 'RECEIVE_SERVICE_ORDER_TIRE_MODEL_STATISTICS';

export const FETCH_ROITREAD_CYCLES = 'FETCH_ROITREAD_CYCLES';
export const RECEIVE_ROITREAD_CYCLES = 'RECEIVE_ROITREAD_CYCLES';
export const FETCH_ROITREAD_CYCLE_HOUR_USAGE_STATISTICS = 'FETCH_ROITREAD_CYCLE_HOUR_USAGE_STATISTICS';
export const RECEIVE_ROITREAD_CYCLE_HOUR_USAGE_STATISTICS =  'RECEIVE_ROITREAD_CYCLE_HOUR_USAGE_STATISTICS';

export const FETCH_AUTOCLAVES = 'FETCH_AUTOCLAVES';
export const RECEIVE_AUTOCLAVES = 'RECEIVE_AUTOCLAVES';

export const FETCH_AUTOCLAVE_CICLOS = 'FETCH_AUTOCLAVE_CICLOS';
export const RECEIVE_AUTOCLAVE_CICLOS = 'RECEIVE_AUTOCLAVE_CICLOS';

export const FETCH_AUTOCLAVE_CICLO_SUBCICLO = 'FETCH_AUTOCLAVE_CICLO_SUBCICLO';
export const RECEIVE_AUTOCLAVE_CICLO_SUBCICLO = 'RECEIVE_AUTOCLAVE_CICLO_SUBCICLO';


export const FETCH_AUTOCLAVE_HISTORICO_INDICADORES = 'FETCH_AUTOCLAVE_HISTORICO_INDICADORES';
export const RECEIVE_AUTOCLAVE_HISTORICO_INDICADORES = 'RECEIVE_AUTOCLAVE_HISTORICO_INDICADORES';

export const FETCH_AUTOCLAVE_UTILIZACAODATA = 'FETCH_AUTOCLAVE_UTILIZACAODATA';
export const RECEIVE_AUTOCLAVE_UTILIZACAODATA = 'RECEIVE_AUTOCLAVE_UTILIZACAODATA'


export const FETCH_AUTOCLAVE_DETALHES_CICLO = 'FETCH_AUTOCLAVE_DETALHES_CICLO';
export const RECEIVE_AUTOCLAVE_DETALHES_CICLO = 'RECEIVE_AUTOCLAVE_DETALHES_CICLO';
export const FETCH_TIRE_BANDS = 'FETCH_TIRE_BANDS';
export const RECEIVE_TIRE_BANDS = 'RECEIVE_TIRE_BANDS';

export const POST_SERVICE_ORDER = 'POST_SERVICE_ORDER';
export const POST_SUCCESS_SERVICE_ORDER = 'POST_SUCCESS_SERVICE_ORDER';

export const POST_SERVICE_ORDER_STEP = 'POST_SERVICE_ORDER_STEP';
export const POST_SUCCESS_SERVICE_ORDER_STEP = 'POST_SUCCESS_SERVICE_ORDER_STEP';

export const POST_AUTOCLAVE_CICLO_ORDEM_SERVICO = 'POST_AUTOCLAVE_CICLO_ORDEM_SERVICO';
export const POST_SUCCESS_AUTOCLAVE_CICLO_ORDEM_SERVICO = 'POST_SUCCESS_AUTOCLAVE_CICLO_ORDEM_SERVICO';


export const FETCH_FOTOGRAFIA_PLANTA = 'FETCH_FOTOGRAFIA_PLANTA';
export const RECEIVE_FOTOGRAFIA_PLANTA = 'RECEIVE_FOTOGRAFIA_PLANTA'

export const FETCH_ESTATISTICA_ETAPA = 'FETCH_ESTATISTICA_ETAPA'
export const RECEIVE_ESTATISTICA_ETAPA = 'RECEIVE_ESTATISTICA_ETAPA'

export const FETCH_ESTABELECIMENTOS = 'FETCH_ESTABELECIMENTOS'
export const RECEIVE_ESTABELECIMENTOS = 'RECEIVE_ESTABELECIMENTOS'
export const SET_FILTER_ESTABELECIMENTO = 'SET_FILTER_ESTABELECIMENTO'

export const FETCH_OS_TIPO_PERGUNTA = 'FETCH_OS_TIPO_PERGUNTA';
export const RECEIVE_OS_TIPO_PERGUNTA = 'RECEIVE_OS_TIPO_PERGUNTA'
export const FETCH_OS_ESTATISTICA_COLA_VERDE = 'FETCH_OS_ESTATISTICA_COLA_VERDE'
export const RECEIVE_OS_ESTATISTICA_COLA_VERDE = 'RECEIVE_OS_ESTATISTICA_COLA_VERDE'

export const FETCH_OPERADORES_ESTATISTICAS = 'FETCH_OPERADORES_ESTATISTICAS';
export const RECEIVE_OPERADORES_ESTATISTICAS = 'RECEIVE_OPERADORES_ESTATISTICAS';

export const FETCH_DIARIO_PRODUCAO = 'FETCH_DIARIO_PRODUCAO';
export const RECEIVE_DIARIO_PRODUCAO = 'RECEIVE_DIARIO_PRODUCAO';

export const FETCH_ACOMPANHAMENTO_OS = 'FETCH_ACOMPANHAMENTO_OS';
export const RECEIVE_ACOMPANHAMENTO_OS= 'RECEIVE_ACOMPANHAMENTO_OS';

export const FETCH_OS_RECEBIDOS_FINALIZADOS = 'FETCH_OS_RECEBIDOS_FINALIZADOS';
export const RECEIVE_OS_RECEBIDOS_FINALIZADOS = 'RECEIVE_OS_RECEBIDOS_FINALIZADOS';


export const FETCH_ETAPAS = 'FETCH_ETAPAS';
export const RECEIVE_ETAPAS = 'RECEIVE_ETAPAS';

export const FETCH_TEMPO_ETAPAS = 'FETCH_TEMPO_ETAPAS';
export const RECEIVE_TEMPO_ETAPAS = 'RECEIVE_TEMPO_ETAPAS';

export const FETCH_LISTA_OS_HEADER = 'FETCH_LISTA_OS_HEADER';
export const RECEIVE_LISTA_OS_HEADER = 'RECEIVE_LISTA_OS_HEADER';

export const FETCH_ORDENS_PARA_CORTE = 'FETCH_ORDENS_PARA_CORTE';
export const RECEIVE_ORDENS_PARA_CORTE = 'RECEIVE_ORDENS_PARA_CORTE';

export const FETCH_ITEM_CODIGO_BARRAS = 'FETCH_ITEM_CODIGO_BARRAS';
export const RECEIVE_ITEM_CODIGO_BARRAS = 'RECEIVE_ITEM_CODIGO_BARRAS';

export const FETCH_ESTACOES_TRABALHO = 'FETCH_ESTACOES_TRABALHO';
export const RECEIVE_ESTACOES_TRABALHO = 'RECEIVE_ESTACOES_TRABALHO';


export const FETCH_PNEUS_NA_CASA = 'FETCH_PNEUS_NA_CASA';
export const RECEIVE_PNEUS_NA_CASA = 'RECEIVE_PNEUS_NA_CASA';

export const FETCH_PNEUS_RECEBIDOS_HOJE = 'FETCH_PNEUS_RECEBIDOS_HOJE';
export const RECEIVE_PNEUS_RECEBIDOS_HOJE = 'RECEIVE_PNEUS_RECEBIDOS_HOJE';
export const FETCH_PNEUS_SAIDOS_HOJE = 'FETCH_PNEUS_SAIDOS_HOJE';
export const RECEIVE_PNEUS_SAIDOS_HOJE = 'RECEIVE_PNEUS_SAIDOS_HOJE';

export const FETCH_PNEUS_PRODUZIDOS_HOJE = 'FETCH_PNEUS_PRODUZIDOS_HOJE';
export const RECEIVE_PNEUS_PRODUZIDOS_HOJE = 'RECEIVE_PNEUS_PRODUZIDOS_HOJE';


export const FETCH_PNEUS_RECUSADOS_REPROVADOS_HOJE = 'FETCH_PNEUS_RECUSADOS_REPROVADOS_HOJE';
export const RECEIVE_PNEUS_RECUSADOS_REPROVADOS_HOJE = 'RECEIVE_PNEUS_RECUSADOS_REPROVADOS_HOJE';

export const  FETCH_PNEUS_RECEBIDOS_POR_DATA = 'FETCH_PNEUS_RECEBIDOS_POR_DATA';
export const RECEIVE_PNEUS_RECEBIDOS_POR_DATA = 'RECEIVE_PNEUS_RECEBIDOS_POR_DATA';

export const  FETCH_PNEUS_ENVIADOS_POR_DATA = 'FETCH_PNEUS_ENVIADOS_POR_DATA';
export const RECEIVE_PNEUS_ENVIADOS_POR_DATA = 'RECEIVE_PNEUS_ENVIADOS_POR_DATA';

export const FETCH_PNEUS_CONCLUIDOS_POR_DATA = 'FETCH_PNEUS_CONCLUIDOS_POR_DATA';
export const RECEIVE_PNEUS_CONCLUIDOS_POR_DATA = 'RECEIVE_PNEUS_CONCLUIDOS_POR_DATA';

export const FETCH_PNEUS_RECUSADOS_REPROVADOS_POR_DATA = 'FETCH_PNEUS_RECUSADOS_REPROVADOS_POR_DATA';
export const RECEIVE_PNEUS_RECUSADOS_REPROVADOS_POR_DATA = 'RECEIVE_PNEUS_RECUSADOS_REPROVADOS_POR_DATA';

export const FETCH_PROCESSOS = 'FETCH_PROCESSOS';
export const RECEIVE_PROCESSOS = 'RECEIVE_PROCESSOS';

export const FETCH_OS_SLA = 'FETCH_OS_SLA';
export const RECEIVE_OS_SLA = 'RECEIVE_OS_SLA';

export const FETCH_METAS = 'FETCH_METAS';
export const RECEIVE_METAS = 'RECEIVE_METAS';

export const FETCH_METAS_PERIODO = 'FETCH_METAS_PERIODO';
export const RECEIVE_METAS_PERIODO = 'RECEIVE_METAS_PERIODO';

export const FETCH_DIARIOS_PRODUCAO = 'FETCH_DIARIOS_PRODUCAO';
export const RECEIVE_DIARIOS_PRODUCAO = 'RECEIVE_DIARIOS_PRODUCAO';

export const FETCH_LISTA_OSs = 'FETCH_LISTA_OSs';
export const RECEIVE_LISTA_OSs = 'RECEIVE_LISTA_OSs';

export const FETCH_SALDOS = 'FETCH_SALDOS';
export const RECEIVE_SALDOS = 'RECEIVE_SALDOS';

export const FETCH_OS_MOVIMENTADAS_PERIODO_DETALHADO = 'FETCH_OS_MOVIMENTADAS_PERIODO_DETALHADO';
export const RECEIVE_OS_MOVIMENTADAS_PERIODO_DETALHADO = 'RECEIVE_OS_MOVIMENTADAS_PERIODO_DETALHADO';

export const FETCH_THOT_I4MONITOR = 'FETCH_THOT_I4MONITOR';
export const RECEIVE_THOT_I4MONITOR = 'RECEIVE_THOT_I4MONITOR';

export const FETCH_LOGIN_LOGOUTS_HOJE = 'FETCH_LOGIN_LOGOUTS_HOJE';
export const RECEIVE_LOGIN_LOGOUTS_HOJE = 'RECEIVE_LOGIN_LOGOUTS_HOJE';

export const FETCH_OPERADORES = 'FETCH_OPERADORES';
export const RECEIVE_OPERADORES = 'RECEIVE_OPERADORES';
export const NEW_OPERADOR = 'NEW_OPERADOR';
export const NEW_OPERADOR_SUCCESS = 'NEW_OPERADOR_SUCCESS';

export const FETCH_LOGIN_LOGOUTS = 'FETCH_LOGIN_LOGOUTS';
export const RECEIVE_LOGIN_LOGOUTS = 'RECEIVE_LOGIN_LOGOUTS';

export const SET_MOCK = 'SET_MOCK';

export const FETCH_V2_OS_MOVIMENTADAS_PERIODO_DETALHADOV2 = 'FETCH_V2_OS_MOVIMENTADAS_PERIODO_DETALHADO';
export const RECEIVE_V2_OS_MOVIMENTADAS_PERIODO_DETALHADOV2 = 'RECEIVE_V2_OS_MOVIMENTADAS_PERIODO_DETALHADO';

export const FETCH_THOT_AUTOCLAVESMONITOR = 'FETCH_THOT_AUTOCLAVESMONITOR';
export const RECEIVE_THOT_AUTOCLAVESMONITOR = 'RECEIVE_THOT_AUTOCLAVESMONITOR';

export const IS_FETCHING_GLBRECEITAS = 'IS_FETCHING_GLBRECEITAS';
export const RECEIVE_GLBRECEITAS = 'RECEIVE_GLBRECEITAS';

export const IS_FETCHING_GLB_RECEITA_CATEGORIAS = 'IS_FETCHING_GLB_RECEITA_CATEGORIAS';
export const RECEIVE_GLB_RECEITA_CATEGORIAS = 'RECEIVE_GLB_RECEITA_CATEGORIAS';
export const PATCH_GLB_RECEITA_EHATIVO = 'PATCH_GLB_RECEITA_EHATIVO';
export const PATCH_GLB_RECEITA_EHATIVO_SUCCESS = 'PATCH_GLB_RECEITA_EHATIVO_SUCCESS';

export const IS_FETCHING_GLB_PNEU_MODELOS = 'IS_FETCHING_GLB_PNEU_MODELOS';
export const RECEIVE_GLB_PNEU_MODELOS = 'RECEIVE_GLB_PNEU_MODELOS';
export const IS_FETCHING_GLB_PNEU_MEDIDAS = 'IS_FETCHING_GLB_PNEU_MEDIDAS';
export const RECEIVE_GLB_PNEU_MEDIDAS = 'RECEIVE_GLB_PNEU_MEDIDAS';
export const IS_FETCHING_GLB_BANDAS = 'IS_FETCHING_GLB_BANDAS';
export const RECEIVE_GLB_BANDAS = 'RECEIVE_GLB_BANDAS';

export const FETCH_RASPA_REPORT_DATA = 'FETCH_RASPA_REPORT_DATA';

export const RECEIVE_RASPA_REPORT_DATA = 'RECEIVE_RASPA_REPORT_DATA';

